import SEOHead, { organizationSchema, breadcrumbSchema } from "@/components/SEOHead";
import MarketingHeader from "@/components/MarketingHeader";
import MarketingFooter from "@/components/MarketingFooter";
import { CtaBlock } from "@/components/FaqBlock";
import { CHANGELOG } from "@/lib/seoData";

export default function ChangelogPage() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEOHead
        title="BreakItDown Changelog — Release Notes & Updates"
        description="Release notes for BreakItDown. New features, bug fixes, and improvements as they ship."
        path="/changelog"
        schemas={[
          organizationSchema(),
          breadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "Changelog", path: "/changelog" },
          ]),
        ]}
      />
      <MarketingHeader />
      <main className="flex-1 max-w-3xl mx-auto px-6 md:px-10 py-12 md:py-16 w-full">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-zinc-500 mb-3">Changelog</p>
        <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight text-zinc-900 leading-tight">
          What's shipped.
        </h1>
        <div className="mt-10 space-y-10 border-l-2 border-zinc-200 pl-6">
          {CHANGELOG.map((c) => (
            <article key={c.version}>
              <div className="text-xs font-mono text-zinc-500">v{c.version} · {c.date}</div>
              <h2 className="text-xl font-semibold text-zinc-900 mt-1">{c.title}</h2>
              <ul className="mt-3 space-y-1.5 text-sm text-zinc-700 list-disc pl-5">
                {c.items.map((i) => <li key={i}>{i}</li>)}
              </ul>
            </article>
          ))}
        </div>
        <CtaBlock />
      </main>
      <MarketingFooter />
    </div>
  );
}
